import React, { useState } from "react";
import button from '../img/button.png';

const ContactForm = () => {
  const [status, setStatus] = useState("Submit");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const { name, email, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    let response = await fetch("https://pixelbear.studio/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });
    setStatus("Submit");
    let result = await response.json();
    alert(result.status);
  };





  return (
    <form onSubmit={handleSubmit}>
      <div>
        
        <input type="text" id="name" placeholder="Name" required />
      </div>
      <div>
        
        <input type="email" id="email" placeholder="Email" required />
      </div>
      <div>
        <textarea id="message" placeholder="Message" required />
      </div>
      <button className="button" style={{padding: '0px', border: 'none', background: `center / contain url(${button})`}} type="submit">{status}</button>

    </form>
  );
};

export default ContactForm;